<template>
  <div>
    <policyHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="../img/announcement.jpg" />
        </div>
      </a-carousel>
    </div>
    <div style="width: 100%;background-color: #fff; min-height: calc(100vh - 159px);">
      <div class="breadBox">
        <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png" />
            当前位置：
          </span>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="tabBox">
        <a-tabs v-model:activeKey="activeKey" type="card">
          <a-tab-pane key="1" tab="通知公告">
            <a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="noticeData">
              <template #renderItem="{ item }">
                <div class="listBox" @click="noticeDetail(item.id)">
                  <div class="leftBox">
                    <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
                    <img v-else src="@/assets/img/defaultPhotoLong.png" style="width: 100%;height: 100%;" alt="">
                  </div>
                  <div class="right">
                    <div class="title">{{ item.title }}</div>
                    <div class="content">{{ item.articleAbstract }}</div>
                    <div class="time">
                      <FieldTimeOutlined />
                      <span style="margin-left: 8px;">{{ item.publishTime }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </a-list>
          </a-tab-pane>
          <a-tab-pane key="2" tab="政策公告">
            <a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="policyData">
              <template #renderItem="{ item }">
                <div class="listBox" @click="onpolicyDetail(item.id)">
                  <div class="leftBox">
                    <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
                    <img v-else src="@/assets/img/defaultPhotoLong.png" style="width: 100%;height: 100%;" alt="">
                  </div>
                  <div class="right">
                    <div class="title">{{ item.title }}</div>
                    <div class="content">{{ item.contentAbstract }}</div>
                    <div class="time">
                      <FieldTimeOutlined />
                      <span style="margin-left: 8px;">{{ item.publishTime }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </a-list>
          </a-tab-pane>
          <a-tab-pane key="3" tab="活动报名">
            <!-- <div>
              <div class="activityContent">
                <div class="activityLi" v-for="item in activityData" :key="item.key" @click="onActivity(item.id)">
                  <div class="activityImg">
                    <img style="width: 100%;height: 100%;" :src="getImg(item.logo)" />
                  </div>
                  <div class="activityInfoTitle">
                    {{ item.title }}
                  </div>
                  <div class="activityInfoTime">
                    报名时间：{{ item.activityTime && item.activityTime.split(' ')[0] }} ~ {{
                      item.signendTime && item.signendTime.split(' ')[0] }}
                  </div>
                  <div class="activityInfoTime">
                    活动时间：{{ item.startDate && item.startDate.split(' ')[0] }} ~ {{ item.endDate && item.endDate.split(' ')[0] }}
                  </div>
                  <div class="activityInfoAddress">
                    地址：{{ item.address }}
                  </div>
                </div>
              </div>
              <div class="pagination">
                <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
              </div>
            </div> -->
            <ActiveryList />
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { FieldTimeOutlined } from '@ant-design/icons-vue';
import { noticeWeb, policyWeb } from "@/api/innovationService";
import { file_service } from "@/api/adminService";
import policyHeader from "./policyHeader"
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import ActiveryList from './activeryList'

const pagination = {
  pageSize: 8,
  showQuickJumper: true,
};
export default {
  name: 'consultation',
  components: {
    FieldTimeOutlined, policyHeader, LayoutFooter, ActiveryList
  },
  mounted() {
    this.getList()
    this.getPolicyList()
    this.title = this.$route.query.type,
      this.activeKey = this.$route.query.activeKey
  },
  data() {
    return {
      pagination,
      noticeData: [],
      policyData: [],
      title: '',
      activeKey: "1",
      current: 1,
      pageSize: 10,
      total: 0,
    }
  },
  methods: {
    getList() {
      this.getAction({
        url: noticeWeb.pageList,
      }).then(res => {
        console.log(res, 'res')
        this.noticeData = res.records
      })
    },
    getPolicyList() {
      this.getAction({
        url: policyWeb.pageList,
        params: { systemType: 'innovation' }
      }).then(res => {
        console.log(res, 'res')
        this.policyData = res.records
      })
    },
    //公告详情
    noticeDetail(id) {
      this.$router.push({
        path: "/Innovation/components/noticeDetail",
        query: { id: id, type: "资讯公告" }
      })
    },
    //政策详情
    onpolicyDetail(id) {
      this.$router.push({
        path: "/Innovation/components/announcement",
        query: { id: id, type: "资讯公告" }
      })
    },
    //活动详情
    onActivity(id) {
      this.$router.push({
        path: "/Innovation/components/activeryDetail",
        query: { id: id, type: "资讯公告" }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }

  .showMoreButton {
    position: absolute;
    top: 55%;
    left: 21.5%;
    width: 170px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background-color: #0048c4;
    color: #fff;
    cursor: pointer;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.tabBox {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 20px 0;

  .listBox {
    overflow: hidden;
    padding: 10px 0;
    cursor: pointer;

    .leftBox {
      float: left;
      width: 24%;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      float: left;
      margin-left: 2%;
      width: 74%;
      font-size: 14px;

      .title {
        padding: 10px 0;
        font-size: 20px;
        color: #333;
        font-weight: 500;
      }

      .content {
        overflow: hidden;
        margin: 10px 0;
        color: #666;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .time {
        padding: 10px 0;
        color: #999;
      }
    }
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab) {
    font-size: 14px;
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active) {
    color: #fff;
    background-color: #1890ff;
  }

  .activityContent {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;

    .activityLi {
      width: 23%;
      margin: 20px 32px 20px 0;
      cursor: pointer;
      border: 1px solid #dedede;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 10px;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;
      border: none;
      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
}

.pagination {
  text-align: center;
  margin-bottom: 20px;
}
</style>
